(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cos-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-cos-variant]'))return;const input=event.target;const buy=input.closest('.cos-buy');buy.querySelector('[data-cos-price]').textContent=input.dataset.price;buy.querySelector('[data-cos-compare]').textContent=input.dataset.compare;const button=buy.querySelector('button[type=submit]');if(button){button.disabled=input.dataset.available!=='true';button.textContent=input.dataset.available==='true'?button.dataset.add:button.dataset.sold;}});
document.addEventListener('click',function(event){const button=event.target.closest('[data-cos-image]');if(!button)return;const gallery=button.closest('.cos-gallery');const main=gallery.querySelector('[data-cos-main]');main.src=button.dataset.cosImage;gallery.querySelectorAll('[data-cos-image]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button))});gallery.querySelector('.cos-thumbs>span').textContent=String(Array.from(gallery.querySelectorAll('[data-cos-image]')).indexOf(button)+1).padStart(2,'0')+' — '+gallery.querySelectorAll('[data-cos-image]').length;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["darila-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const observers = new WeakMap();
  const authorSelector = '.jm-reviewer-info__name, .jdgm-rev__author';

  function shortenName(value) {
    const parts = value.trim().split(/\s+/);
    return parts.length > 1
      ? parts[0] + ' ' + Array.from(parts[parts.length - 1])[0] + '.'
      : parts[0];
  }

  function formatNames(section) {
    section.querySelectorAll(authorSelector).forEach((author) => {
      const shortName = shortenName(author.textContent);
      if (author.textContent !== shortName) author.textContent = shortName;
      ['title', 'aria-label'].forEach((attribute) => {
        if (author.hasAttribute(attribute) && author.getAttribute(attribute) !== shortName) {
          author.setAttribute(attribute, shortName);
        }
      });
    });
  }

  function initialize(root) {
    root.querySelectorAll('.darila-reviews').forEach((section) => {
      if (observers.has(section)) return;
      formatNames(section);
      const observer = new MutationObserver(() => formatNames(section));
      observer.observe(section, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['title', 'aria-label']
      });
      observers.set(section, observer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.darila-reviews').forEach((section) => {
      const observer = observers.get(section);
      if (observer) observer.disconnect();
      observers.delete(section);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["darila-skin"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('darila-ingredient-carousel')) {
  customElements.define('darila-ingredient-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.di-track');
      this.cards = [...this.querySelectorAll('.di-card')];
      this.dots = [...this.querySelectorAll('.di-dot')];
      this.controls = this.querySelector('.di-controls');
      this.buttons = [...this.querySelectorAll('.di-arrow')];
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dots.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
      this.buttons.forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction)), options));
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) this.go(index);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    go(index) {
      const clamped = Math.max(0, Math.min(index, this.positions.length - 1));
      const position = this.positions[clamped];
      this.track.scrollTo({ left: position, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      this.controls.hidden = maximum < 4;
      this.positions = [...new Set(this.cards.map(card => Math.round(Math.min(maximum, card.offsetLeft - this.cards[0].offsetLeft))))];
      this.index = this.positions.reduce((nearest, position, index) => Math.abs(position - left) < Math.abs(this.positions[nearest] - left) ? index : nearest, 0);
      this.buttons[0].disabled = left < 3;
      this.buttons[1].disabled = left >= maximum - 3;
      this.dots.forEach((dot, i) => {
        dot.hidden = i >= this.positions.length;
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soreli-announcement"] && !Shopify.designMode) return;
  try {
    
function soreliSaleDeadline(now, timeZone) {
  const formatter = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  const parts = date => Object.fromEntries(formatter.formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const today = parts(now);
  const midnight = Date.UTC(today.year, today.month - 1, today.day + 1);
  let target = midnight;
  for (let attempt = 0; attempt < 3; attempt++) {
    const atTarget = parts(new Date(target));
    const wallTime = Date.UTC(atTarget.year, atTarget.month - 1, atTarget.day, atTarget.hour, atTarget.minute, atTarget.second);
    target += midnight - wallTime;
  }
  return target;
}
if (!customElements.get('soreli-sale-countdown')) {
  customElements.define('soreli-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      this.timeZone = this.dataset.timeZone || 'America/Toronto';
      try { new Intl.DateTimeFormat('en', {timeZone: this.timeZone}).format(); }
      catch { this.timeZone = 'America/Toronto'; }
      this.hours = this.querySelector('[data-sale-hours]');
      this.minutes = this.querySelector('[data-sale-minutes]');
      this.seconds = this.querySelector('[data-sale-seconds]');
      this.deadline = 0;
      this.tick = () => {
        const now = new Date();
        if (now.getTime() >= this.deadline) this.deadline = soreliSaleDeadline(now, this.timeZone);
        const remaining = Math.max(0, Math.ceil((this.deadline - now.getTime()) / 1000));
        this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        this.minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
        this.seconds.textContent = String(remaining % 60).padStart(2, '0');
      };
      this.tick();
      this.interval = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.tick);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soreli-header"] && !Shopify.designMode) return;
  try {
    
async function refreshDarilaCart() {
  const links = document.querySelectorAll('[data-soreli-cart]');
  if (!links.length) return;
  try {
    const response = await fetch(links[0].dataset.cartUrl + '.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    links.forEach(link => {
      link.querySelector('[data-cart-number]').textContent = cart.item_count;
      link.querySelector('[data-cart-count]').hidden = cart.item_count === 0;
    });
  } catch {}
}
window.addEventListener('pageshow', refreshDarilaCart);
document.addEventListener('cart:update', refreshDarilaCart);
document.addEventListener('cart:refresh', refreshDarilaCart);
document.addEventListener('shopify:section:load', refreshDarilaCart);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') refreshDarilaCart();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soreli-product"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('soreli-media-gallery')) {
  customElements.define('soreli-media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      if (!this.panels.length) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.classList.add('is-ready');
      const controls = this.querySelector('.soreli-gallery-thumbs');
      if (controls) controls.hidden = false;
      this.select = (id) => {
        this.panels.forEach(panel => {
          const active = panel.id === id;
          panel.classList.toggle('is-current', active);
          panel.setAttribute('aria-hidden', String(!active));
          if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.getAttribute('aria-controls') === id)));
      };
      this.addEventListener('click', event => {
        const arrow = event.target.closest('[data-gallery-direction]');
        if (arrow && this.contains(arrow)) {
          const index = this.panels.findIndex(panel => panel.classList.contains('is-current'));
          const next = (index + Number(arrow.dataset.galleryDirection) + this.panels.length) % this.panels.length;
          this.select(this.panels[next].id);
          const activeThumb = this.thumbs.find(thumb => thumb.getAttribute('aria-controls') === this.panels[next].id);
          if (activeThumb) {
            const strip = activeThumb.parentElement;
            const left = activeThumb.offsetLeft - strip.offsetLeft;
            if (left < strip.scrollLeft) strip.scrollLeft = left;
            else if (left + activeThumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + activeThumb.offsetWidth - strip.clientWidth;
          }
        }
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb && this.contains(thumb)) this.select(thumb.getAttribute('aria-controls'));
      }, options);
      this.addEventListener('keydown', event => {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
        const index = this.thumbs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.thumbs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.thumbs.length) % this.thumbs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.thumbs.length - 1;
        else return;
        event.preventDefault();
        this.thumbs[next].focus();
        this.select(this.thumbs[next].getAttribute('aria-controls'));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-gallery-panel]');
        if (panel) this.select(panel.id);
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, options);
      this.select(this.panels[0].id);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}

function updateDarilaPurchase(buy) {
  const variant = buy.querySelector('[data-cos-variant]:checked');
  if (!variant) return;
  const subscription = buy.querySelector('[data-purchase-mode][value="subscription"]');
  const currentPlans = buy.querySelector('[data-plan-variant="' + variant.value + '"]');
  const select = currentPlans?.querySelector('select');
  const hasPlan = Boolean(select?.options.length);
  if (subscription) {
    subscription.disabled = !hasPlan;
    if (!hasPlan) subscription.checked = false;
  }
  const subscribed = Boolean(subscription?.checked && hasPlan);
  buy.querySelectorAll('[data-plan-variant]').forEach(label => {
    const active = subscribed && label === currentPlans;
    label.hidden = !active;
    label.querySelector('select').disabled = !active;
  });
  const details = buy.querySelector('[data-plan-details]');
  if (details) details.hidden = !subscribed;
  const plan = subscribed ? select.selectedOptions[0] : null;
  const sellingPlan = buy.querySelector('[data-selling-plan]');
  if (sellingPlan) {
    sellingPlan.disabled = !plan;
    sellingPlan.value = plan?.value || '';
  }
  const description = buy.querySelector('[data-plan-description]');
  if (description) description.textContent = plan?.dataset.description || '';
  buy.querySelectorAll('[data-cos-variant]').forEach(input => {
    const options = buy.querySelector('[data-plan-variant="' + input.value + '"] select');
    const match = subscribed ? Array.from(options?.options || []).find(option => option.value === plan.value) || options?.selectedOptions[0] : null;
    input.closest('.cos-offer').querySelector('[data-offer-price]').textContent = match?.dataset.money || input.dataset.money;
  });
  buy.querySelector('[data-cos-price]').textContent = plan?.dataset.price || variant.dataset.price;
  buy.querySelector('[data-cos-compare]').textContent = variant.dataset.compare;
  buy.querySelector('[data-cos-recurring]').hidden = !subscribed;
  const button = buy.querySelector('button[type="submit"]');
  const available = variant.dataset.available === 'true' && Number(plan?.dataset.priceCents || variant.dataset.priceCents) > 0;
  button.disabled = !available;
  button.textContent = available ? button.dataset.add : button.dataset.sold;
}
document.addEventListener('change', event => {
  if (!event.target.matches('[data-cos-variant], [data-purchase-mode], [data-plan-select]')) return;
  const buy = event.target.closest('[data-soreli-purchase]');
  if (buy) updateDarilaPurchase(buy);
});
document.addEventListener('submit', async event => {
  const form = event.target;
  const buy = form.closest('[data-soreli-purchase]');
  if (!buy) return;
  event.preventDefault();
  if (form.dataset.checkoutBusy === 'true') return;
  updateDarilaPurchase(buy);
  const variant = form.querySelector('[data-cos-variant]:checked');
  const error = buy.querySelector('[data-checkout-error]');
  if (!variant || variant.dataset.available !== 'true') return;
  const item = { id: Number(variant.value), quantity: 1 };
  const sellingPlan = form.querySelector('[data-selling-plan]:not(:disabled)');
  if (sellingPlan?.value) item.selling_plan = Number(sellingPlan.value);
  const cartUrl = buy.dataset.cartUrl.replace(/\/$/, '');
  form.dataset.checkoutBusy = 'true';
  error.hidden = true;
  form.querySelector('button[type="submit"]').disabled = true;
  try {
    const cleared = await fetch(cartUrl + '/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!cleared.ok) throw new Error('Could not reset checkout');
    const added = await fetch(cartUrl + '/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    if (!added.ok) throw new Error('Could not add selected offer');
    const checked = await fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!checked.ok) throw new Error('Could not verify checkout');
    const cart = await checked.json();
    if (cart.items.length !== 1 || cart.items[0].variant_id !== item.id || cart.items[0].quantity !== 1) {
      throw new Error('Checkout does not contain exactly one selected offer');
    }
    window.location.assign(buy.dataset.checkoutUrl);
  } catch (cause) {
    console.error(cause);
    error.hidden = false;
    delete form.dataset.checkoutBusy;
    updateDarilaPurchase(buy);
  }
});
function initializeDarilaPurchases(root = document) {
  root.querySelectorAll('[data-soreli-purchase]').forEach(buy => {
    const form = buy.querySelector('form');
    if (form) delete form.dataset.checkoutBusy;
    updateDarilaPurchase(buy);
  });
}
initializeDarilaPurchases();
window.addEventListener('pageshow', () => initializeDarilaPurchases());
document.addEventListener('shopify:section:load', event => initializeDarilaPurchases(event.target));


if (!customElements.get('soreli-sticky-cart')) {
  customElements.define('soreli-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.original = this.form?.querySelector('.cos-buy-row button[type="submit"]');
      this.button = this.querySelector('button');
      if (!this.original || !this.button) return;
      this.sync = () => {
        this.button.disabled = this.original.disabled;
        this.button.textContent = this.original.textContent;
      };
      this.update = () => {
        this.frame = null;
        const header = document.querySelector('.cos-header');
        const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
        this.hidden = !this.original.getClientRects().length || this.original.getBoundingClientRect().bottom > headerBottom;
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.original, { attributes: true, childList: true, subtree: true, characterData: true });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(document.body);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      window.addEventListener('pageshow', this.schedule);
      this.sync();
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.schedule);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
